import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { combineClassNames } from 'core/css';
import DisclaimerTarget from '../../common/notifications/DisclaimerTarget';

const TextColumnContent = ({ header, placeholderText, disclaimer }) => {
  if (!header) {
    return (
      <div className="features-compare-header-cell__text--primary">
        {placeholderText}
      </div>
    );
  }

  const primaryContent = (
    <span className="features-compare-header-cell__text--primary">
      {header.primaryText}
    </span>
  );

  const secondaryContent = (
    <span dangerouslySetInnerHTML={{ __html: header.secondaryText }} />
  );

  const tertiaryContent = (
    <span dangerouslySetInnerHTML={{ __html: header.tertiaryText }} />
  );

  const msrpContent = header.msrp && (
    <div>
      <span className="features-compare-header-column__label">
        <Translate value="component.trim.compare.msrp" />{' '}
      </span>
      <DisclaimerTarget
        disclaimer={disclaimer}
        stopPropagation={true}
        className="features-compare-header-column__msrp">
        {header.msrp}
      </DisclaimerTarget>
    </div>
  );

  return (
    <div>
      <div>
        {primaryContent}{' '}
        {header.tertiaryText ? (
          <span>
            {secondaryContent}
            {', '}
            {tertiaryContent}
          </span>
        ) : (
          secondaryContent
        )}
      </div>
      {msrpContent}
    </div>
  );
};

const ButtonColumn = ({ disableEdit }) => {
  if (disableEdit) {
    return null;
  }
  return (
    <div className="features-compare-header-column__icon-column">
      <button>
        <SvgIcon
          name="plus-circle"
          className="features-compare-header-column__icon"
        />
      </button>
    </div>
  );
};

class FeaturesCompareHeaderCell extends React.Component {
  static defaultProps = {
    disableEdit: false
  };

  onSelect = () => {
    const { disableEdit, onSelect } = this.props;
    if (!disableEdit) {
      onSelect();
    }
  };

  render() {
    const { header, disableEdit } = this.props;

    const className = combineClassNames([
      'features-compare-header-column',
      header
        ? 'features-compare-header-column--selected'
        : 'features-compare-header-column--available',
      disableEdit ? 'features-compare-header-column--locked' : ''
    ]);

    return (
      <div className={className} onClick={this.onSelect}>
        <div className="features-compare-header-column__content-column">
          <TextColumnContent {...this.props} />
        </div>
        <ButtonColumn disableEdit={disableEdit} />
      </div>
    );
  }
}

FeaturesCompareHeaderCell.propTypes = {
  disableEdit: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  header: PropTypes.object,
  placeholderText: PropTypes.string,
  disclaimer: PropTypes.string
};

export default FeaturesCompareHeaderCell;
